import React, { useEffect } from "react";
import { useAuthStore } from '../../store/loginStore';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import VendasNoMes from '../../components/GraficoDeVendas';
import TiposDePagamentos from '../../components/GraficoDeTiposPagamentos.js'
import ProdutosMaisVendidos from '../../components/GraficoProdMaisVendidos.js'
import GraficoComFiltro from '../../components/GraficoVendasComFiltros.js'
import VendasPorTerminal from '../../components/GraficoVendasPorTerminal.js';
import { useProdutosStore } from '../../store/ProdutosStore';
import { useVendasStore } from '../../store/VendasStore';
import { useTerminaltore } from '../../store/TerminaisStores.js';
import apiClient from '../../api/client.js';

export default function HomePage() {

    const { logout } = useAuthStore()

    const {
        carregando,
        setHankingDeProdutos,
        setTotalVendidos,
        dadosFitroParaGrafico,
        seProdutosParaGrafico
    } = useProdutosStore();

    const {
        setAno,
        setMesAtual,
        setTotalVendido,
        setQtdPix,
        setQtdDebito,
        setQtdCredito,
        setVendasPix,
        setVendasDebito,
        setVendasCredito,
        setSomatorioMeiosPagamento,
        setMostrarGraficoValores,
        setMostrarGraficoMeiosUsados,
    } = useVendasStore();

    const {
        setVendas_por_terminal_mes_corrente,
        setQtd_terminais_ativos
    } = useTerminaltore();


    function teste() {
        logout()
    }


    useEffect(() => {
        async function fetchDados() {

            const filtros = await useProdutosStore.getState().dadosFitroParaGrafico || {};
            
            const resposta = await apiClient.get('/GetAtualizacoesDadVendas', {
                params: {
                    data_fim: filtros?.data_fim || '',
                    data_inicio: filtros?.data_inicio || '',
                    grupo: filtros?.grupo || '',
                    subgrupo: filtros.subgrupo || '',
                    qtd_registros: filtros?.qtd_registros || '10',
                    nome_produto: filtros?.nome_produto || '',
                }
            })

            const data = resposta.data;

            const produtos = data.produtos?.original;
            setHankingDeProdutos(produtos.ranking_produtos);
            setTotalVendidos(Number(produtos.total_de_produtos_venidos) || 0);

            const pagamentos = data.pagamentos?.original || 0;
            setAno(Number(pagamentos.ano));
            setMesAtual(Number(pagamentos.mes));
            setTotalVendido(pagamentos.total);
            setVendasPix(pagamentos.pix);
            setVendasDebito(pagamentos.debito);
            setVendasCredito(pagamentos.credito);
            setQtdPix(pagamentos.qtd_de_uso_do_pix);
            setQtdDebito(pagamentos.qtd_de_uso_do_debito);
            setQtdCredito(pagamentos.qtd_de_uso_do_credito);
            setSomatorioMeiosPagamento(pagamentos.somatorio_do_meios_de_pagamentos);

            const vendas_por_termina = data.vendas?.original.dados_das_vendas_por_terminais;
            const qtd_terminais_ativos = data.vendas?.original.qtd_terminais_ativos;

            setVendas_por_terminal_mes_corrente(vendas_por_termina);
            setQtd_terminais_ativos(qtd_terminais_ativos);

            const produtos_filtrados = data.filtro_de_produtos.original.produtos ?? [];
            seProdutosParaGrafico(produtos_filtrados);
        }

        fetchDados(); // primeiro fetch imediato

        const intervalId = setInterval(fetchDados, 10000); // polling a cada 10s

        return () => clearInterval(intervalId); // limpa o interval ao desmontar o componente
    }, []);

    return (
        <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' } }}>
            
            <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
                Filtro de produtos vendidos
            </Typography>
            <Grid
                container
                spacing={2}
                columns={12}
                sx={{ mb: (theme) => theme.spacing(2) }}
            >
                <GraficoComFiltro />
            </Grid>

            <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
                10 Produtos mais vendidos no mês
            </Typography>
            <Grid
                container
                spacing={2}
                columns={12}
                sx={{ mb: (theme) => theme.spacing(2) }}
            >
                <ProdutosMaisVendidos />
            </Grid>
            <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
                Valores das vendas
            </Typography>
            <Grid
                container
                spacing={2}
                columns={12}
                sx={{ mb: (theme) => theme.spacing(2) }}
            >
                <VendasNoMes />
            </Grid>
            <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
                Tipos de pagamentos
            </Typography>
            <Grid
                container
                spacing={2}
                columns={12}
                sx={{ mb: (theme) => theme.spacing(2) }}
            >
                <TiposDePagamentos />
            </Grid>
            <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
                Vendas por terminal
            </Typography>
            <Grid
                container
                spacing={2}
                columns={12}
                sx={{ mb: (theme) => theme.spacing(2) }}
            >
                <VendasPorTerminal />
            </Grid>
        </Box>
    )

}